<div class="d-flex flex-column h-100 w-100" data-cy="DIV-ec92">
  <app-common-header title="Mes statuts personnalisés" [title]="'STATUS.MES_STATUTS_PERSONALISES' | translate"></app-common-header>
  <app-flex-fill-container scrollSpyElement="flex-fill-container">
    <app-status-search-form (search)="searchBy = $event" (statusCreated)="onCreate()"> </app-status-search-form>
    <app-status-list #statusListComponent [searchBy]="searchBy" (delete)="onDelete($event.id)" (edit)="onEdit($event)"> </app-status-list>
  </app-flex-fill-container>
</div>
